/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompaniesBaseUnitsCountQueryVariables = Exact<{
  companiesIds: Array<string> | string;
}>;


export type CompaniesBaseUnitsCountQuery = { base_unit_aggregate: { aggregate: { count: number } | null } };


export const CompaniesBaseUnitsCountDocument = /*#__PURE__*/ gql`
    query CompaniesBaseUnitsCount($companiesIds: [uuid!]!) {
  base_unit_aggregate(
    where: {_and: {company_id: {_in: $companiesIds}, availability: {_eq: AVAILABLE}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCompaniesBaseUnitsCountQuery__
 *
 * To run a query within a React component, call `useCompaniesBaseUnitsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesBaseUnitsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesBaseUnitsCountQuery({
 *   variables: {
 *      companiesIds: // value for 'companiesIds'
 *   },
 * });
 */
export function useCompaniesBaseUnitsCountQuery(baseOptions: Apollo.QueryHookOptions<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables> & ({ variables: CompaniesBaseUnitsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>(CompaniesBaseUnitsCountDocument, options);
      }
export function useCompaniesBaseUnitsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>(CompaniesBaseUnitsCountDocument, options);
        }
// @ts-ignore
export function useCompaniesBaseUnitsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>): Apollo.UseSuspenseQueryResult<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>;
export function useCompaniesBaseUnitsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>): Apollo.UseSuspenseQueryResult<CompaniesBaseUnitsCountQuery | undefined, CompaniesBaseUnitsCountQueryVariables>;
export function useCompaniesBaseUnitsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>(CompaniesBaseUnitsCountDocument, options);
        }
export type CompaniesBaseUnitsCountQueryHookResult = ReturnType<typeof useCompaniesBaseUnitsCountQuery>;
export type CompaniesBaseUnitsCountLazyQueryHookResult = ReturnType<typeof useCompaniesBaseUnitsCountLazyQuery>;
export type CompaniesBaseUnitsCountSuspenseQueryHookResult = ReturnType<typeof useCompaniesBaseUnitsCountSuspenseQuery>;
export type CompaniesBaseUnitsCountQueryResult = Apollo.QueryResult<CompaniesBaseUnitsCountQuery, CompaniesBaseUnitsCountQueryVariables>;